'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var feisStagesPrefix = exports.feisStagesPrefix = function feisStagesPrefix(feis_id) {
  return IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/stages';
};
var stagesPath = exports.stagesPath = function stagesPath(feis_id) {
  return ['feiseanna', 'stages', feis_id, 'all'];
};
var unscheduledPath = exports.unscheduledPath = function unscheduledPath(feis_id) {
  return ['feiseanna', 'unscheduledEvents', feis_id, 'all'];
};

var stagesAreLoading = exports.stagesAreLoading = function stagesAreLoading(state, feis_id) {
  return !state.getIn(['feiseanna', 'stages', feis_id]) || state.getIn(['feiseanna', 'stages', feis_id, 'loading']);
};

var stageEventsAreLoading = exports.stageEventsAreLoading = function stageEventsAreLoading(state, stage_id) {
  return !!state.getIn(['loading', stage_id]);
};

var stageEventsError = exports.stageEventsError = function stageEventsError(state) {
  return !!state.getIn(['stages', 'syncError']);
};

var unscheduledEventsAreLoading = exports.unscheduledEventsAreLoading = function unscheduledEventsAreLoading(state, feis_id) {
  return !state.getIn(['feiseanna', 'unscheduledEvents', feis_id]) || state.getIn(['feiseanna', 'unscheduledEvents', feis_id, 'loading']);
};

var eventsOnStagePath = exports.eventsOnStagePath = function eventsOnStagePath(stage_id) {
  return ['stages', 'events', stage_id];
};

var getStage = exports.getStage = function getStage(state, stage_id) {
  return state.getIn(['stages', 'one', stage_id]);
};

var getStages = exports.getStages = function getStages(state, feis_id) {
  return state.getIn(stagesPath(feis_id));
};

var getEventsOnStage = exports.getEventsOnStage = function getEventsOnStage(state, stage_id) {
  return state.getIn(eventsOnStagePath(stage_id));
};

var getEventsUnscheduled = exports.getEventsUnscheduled = function getEventsUnscheduled(state, feis_id) {
  return state.getIn(unscheduledPath(feis_id));
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/paths.js
// module id = 19
// module chunks = 0